// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Ol-z","image":"Pl-z","imageNoBackground":"Ql-z"};